export default {
  buttons: {
    next: "Next",
    prev: "Back",
    skip: "Skip",
    done: "Done",
    gotIt: "Got it",
  },
  messages: {
    dontShowAgainLabel: "Don't show this again",
    stepNumbersOfLabel: "of",
  },
};
